import { useState } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import EvidenceRecord from '@/frontend/features/Fde/investigations/EvidenceRecord'
import EvidenceTable from '@/frontend/features/Fde/investigations/EvidenceTable'
import type { BusinessEvidenceView, InvestigationLabels } from '@/frontend/features/Fde/investigations/types'

interface Props { view: BusinessEvidenceView; copy: InvestigationLabels }

export default function EvidenceValues({ view, copy }: Props) {
  const [position, setPosition] = useState(0)
  const [table, setTable] = useState(false)
  const index = Math.min(position, view.rows.length - 1)
  const multiple = view.rows.length > 1
  if (index < 0) return null
  const recordLabel = copy.business_record_position.replace('%{current}', String(index + 1)).replace('%{total}', String(view.rows.length))
  return <div className="grid min-w-0 gap-4">
    {multiple && <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex flex-wrap items-center gap-2">
        <p aria-live="polite" className="text-xs text-muted-foreground">{table ? copy.business_comparison : recordLabel}</p>
        {!table && <div className="flex items-center gap-1">
          <button type="button" aria-label={copy.business_record_previous} disabled={index === 0} onClick={() => setPosition(index - 1)} className="rounded-sm p-1 text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-30"><ChevronLeft className="size-4" aria-hidden /></button>
          <button type="button" aria-label={copy.business_record_next} disabled={index === view.rows.length - 1} onClick={() => setPosition(index + 1)} className="rounded-sm p-1 text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-30"><ChevronRight className="size-4" aria-hidden /></button>
        </div>}
      </div>
      <button type="button" onClick={() => setTable(!table)} aria-pressed={table} className="rounded-sm text-xs font-medium text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">{table ? copy.business_by_record : copy.business_compare_table}</button>
    </div>}
    {table ? <EvidenceTable rows={view.rows} columns={view.columns} rowIndices={view.row_indices} copy={copy} />
      : <EvidenceRecord row={view.rows[index]} columns={view.columns} copy={copy} />}
  </div>
}
